import {Link} from 'react-router-dom';
import Icon from '../Icon';
import {dueLabel, isOverdue} from '../../lib/todos';
import {Post} from '../../types';

// One to-do (DESIGN.md §6, To do): a 44px round tick, the words, a quiet line (when · plant ·
// place, a repeat glyph), and the photo of the tell it follows, or its own.
type Props = {todo: Post; today: string; onDone?: (todo: Post) => void; onReopen?: (todo: Post) => void};

export default function TodoRow({todo, today, onDone, onReopen}: Props) {
    const done = todo.doneAt !== null;
    const thumb = todo.photos[0]?.thumbUrl ?? todo.follows?.thumbUrl ?? null;
    const overdue = !done && isOverdue(todo, today);
    const meta = [done ? null : dueLabel(todo.dueLocal, today), todo.plants.map(p => p.label).join(', '), todo.place?.name, todo.follows ? 'from your tell' : null].filter(Boolean).join(' · ');

    return (
        <div className={`flex min-h-[64px] items-center gap-3 py-2 ${done ? 'opacity-60' : ''}`}>
            <button
                type="button"
                aria-label={done ? `Not done yet: ${todo.title}` : `Done: ${todo.title}`}
                aria-pressed={done}
                onClick={() => (done ? onReopen?.(todo) : onDone?.(todo))}
                className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-pill border-[1.5px] ${done ? 'border-shoot bg-shoot text-on-shoot' : 'border-line bg-surface text-transparent hover:text-ink-3'}`}
            >
                <Icon name="check" size={20} strokeWidth={2.4} />
            </button>
            <Link to={`/todo/${todo.id}`} className="flex min-w-0 flex-1 items-center gap-3 no-underline">
                <span className="min-w-0 flex-1">
                    <span className={`block truncate font-semibold ${done ? 'line-through' : ''}`}>{todo.title || 'To do'}</span>
                    <span className={`meta flex items-center gap-1 truncate ${overdue ? 'font-semibold text-rust' : ''}`}>
                        {todo.repeat && <Icon name="calendar" size={14} className="shrink-0" />}
                        <span className="truncate">
                            {todo.repeat ? `${todo.repeat === 'weekly' ? 'Every week' : 'Every year'} · ` : ''}
                            {meta}
                        </span>
                    </span>
                </span>
                {thumb && <img src={thumb} alt="" loading="lazy" className="h-10 w-10 shrink-0 rounded-[11px] object-cover" />}
            </Link>
        </div>
    );
}
